module.exports = __webpack_public_path__ + "assets/more.ac0d142d.svg";